// 处理OSS用户头像
const avatarOss = (avatar?: string): string => {
  if (!avatar) {
    return ''
  }

  const urlParam = 'x-oss-process=image/resize,m_fill,w_150,h_150,limit_0'
  if (!/^http/.test(avatar)) {
    return avatar
  } else {
    const spl: string = /\?/.test(avatar) ? '&' : '?'

    return `${avatar}${spl}${urlParam}`
  }
}

const install = (app) => {
  app.config.globalProperties.$avatarOss = avatarOss
}

export default install

/**
 * decimalPlaces 希望保留的小数位数 | number 格式化数字
 *  处理小数 不四舍五入
 */

const handleNumberDigit = (number = 0, decimalPlaces = 1) => {
  if (!number) {
    return 0
  }
  // 计算需要乘以的倍数
  let multiplier = Math.pow(10, decimalPlaces)

  // 对原始数值进行处理
  number *= multiplier
  number = Math.floor(number) // 向下取整
  number /= multiplier
  return number
}

// 阅读量、评论量、点赞量等类型数据数量（n）展示规则如下：
export const pvcvgv = (val: number): number | undefined | string => {
  try {
    if (!val) {
      return 0
    }
    if (isNaN(val)) {
      return 0
    }
    if (val < 0) {
      return 0
    }
    if (val < 1000) {
      return val
    }
    if (1000 <= val && val < 10000) {
      // const a = (val / 1000).toFixed(1)
      const a = handleNumberDigit(val / 1000)
      const reg = /^(\d+)\.0$/g
      if (reg.test(a)) {
        if (val == RegExp.$1 * 1000) {
          return RegExp.$1 + 'k'
        } else {
          return RegExp.$1 + 'k+'
        }
      } else {
        if (val == a * 1000) {
          return a + 'k'
        } else {
          return a + 'k+'
        }
      }
    }
    // 1w-10w
    if (10000 <= val && val < 100000) {
      // const a = (val / 10000).toFixed(1)
      const a = handleNumberDigit(val / 10000)
      const reg = /^(\d+)\.0$/g
      if (reg.test(a)) {
        if (val == RegExp.$1 * 10000) {
          return RegExp.$1 + 'w'
        } else {
          return RegExp.$1 + 'w+'
        }
      } else {
        if (val == a * 10000) {
          return a + 'w'
        } else {
          return a + 'w+'
        }
      }
    }
    // 10w -100w
    if (100000 <= val && val < 1000000) {
      const a = handleNumberDigit(val / 10000, 0)
      return a + 'w+'
    }
    // 100w+
    if (val >= 1000000) {
      return '100w+'
    }
  } catch (error) {
    console.warn(error, '------warn in pvcvgv')
    return val
  }
}

// 时间
export const timeFilter = (val: string): string => {
  if (!val) return ''
  val = val.toString()
  const dateTimeStamp = new Date(val.replace(/-/g, '/')).getTime()
  // console.log(dateTimeStamp);
  const monthDate = val.substring(5, 16)
  const yearDate = val.substring(0, 16)
  const minute = 1000 * 60
  const hour = minute * 60
  const day = hour * 24
  const now = new Date().getTime()
  const diffValue = now - dateTimeStamp
  const dayC = diffValue / day
  const hourC = diffValue / hour
  const minC = diffValue / minute
  //console.log(parseInt(dayC));
  if (parseInt(dayC) >= 365) {
    val = yearDate
  } else if (parseInt(dayC) >= 2) {
    val = monthDate
  } else if (parseInt(dayC) >= 1) {
    val = '昨天'
  } else if (parseInt(hourC) >= 1) {
    val = parseInt(hourC) + '小时前'
  } else if (parseInt(minC) > 5) {
    val = parseInt(minC) + '分钟前'
  } else if (parseInt(minC) <= 5) {
    val = '刚刚'
  }
  return val
}

/**
 * 文字过长转化 英文和数字算0，5个文字
 *
 * @param {string} str -  字符串
 * @param {number} maxNum - 最大位数
 * @returns {number} -  获取前maxNum个文字+...
 */
export const overLengthChange = (str, maxNum) => {
  if (!str) return
  const chineseLength = 1
  const oheterLength = 0.5
  let count = 0
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i)

    if (charCode >= 0x4e00 && charCode <= 0x9fa5) {
      count += chineseLength
    } else if (charCode >= 0x30 && charCode <= 0x39) {
      count += oheterLength
    } else if (/[a-zA-Z]/.test(str[i])) {
      count += oheterLength
    }
    if (count > maxNum) {
      return str.substring(0, i) + '...'
    }
  }

  // if (count > maxNum) {
  //   str = str.substring(0, maxNum) + '...'
  // }
  return str
}
